/* eslint-disable @typescript-eslint/only-throw-error -- redirect é o contrato do TanStack Router */
import { createFileRoute, redirect } from '@tanstack/react-router';

// Caminhos antigos das abas da transitória (`router.tsx:503-517`): caem na visualização com `?tab=`.
const TABS = ['transferencias', 'pix', 'pagamentos'] as const;

export const Route = createFileRoute('/_app/contas-digitais/contas/$bankAccountId/visualizar/$tab')({
  beforeLoad: ({ params }) => {
    const tab = TABS.find((item) => item === params.tab);
    throw redirect({ to: '/contas-digitais/contas/$bankAccountId/visualizar', params: { bankAccountId: params.bankAccountId }, search: tab ? { tab } : {}, replace: true });
  },
});
